import Icons from "../../../../../components/icons";
import { DataGrid, DataGridHeader, DataGridRow, DataGridCell } from "components/ui/data-grid";

const HistoryGrid = ({ data }) => {
  return (
    <DataGrid columns="minmax(0,2fr) minmax(0,1fr) minmax(0,1fr)" minWidth={500}>
      <DataGridHeader>
        <DataGridCell className="text-md !text-muted-foreground">Action</DataGridCell>
        <DataGridCell className="text-md !text-muted-foreground">Date</DataGridCell>
        <DataGridCell className="text-md !text-muted-foreground">User</DataGridCell>
      </DataGridHeader>

      {data?.map((item) => (
        <DataGridRow key={item.id}>
          <DataGridCell className="text-md flex items-center">
            {item?.file_name && <Icons id={"fileIcon"} />}
            <span className="ml-1 truncate">{item?.file_name || item?.website_url || 'form'}</span>
          </DataGridCell>

          <DataGridCell>
            <p className="px-[15px] rounded-full !w-fit !h-[27px] flex justify-center items-center text-md">
              {item?._created_at?.split('T')?.[0]?.split('-').reverse().join('/')}
            </p>
          </DataGridCell>

          <DataGridCell className="text-md">
            {item?.username}
          </DataGridCell>
        </DataGridRow>
      ))}
    </DataGrid>
  );
};

export default HistoryGrid;
